var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DForm',_vm._g(_vm._b({},'DForm',_vm.$attrs,false),_vm.$listeners),[_c('DField',{key:"alias",staticClass:"mb-6",attrs:{"field":"text","field-style":"1","label":"Alias","rules":_vm.rules,"dense":""}}),_c('DField',{key:"file",attrs:{"field":"file","field-style":"1","label":"Archivo","rules":_vm.rules,"dense":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }